import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { UiModeService } from '../../services/ui-mode.service';

@Component({
  selector: 'app-menu-v2',
  templateUrl: './menu-v2.component.html'
})
export class MenuV2Component implements OnInit {
  public imageURL: string = 'https://keongkee.com.my/api/public/static';
  public defaultImage: string = 'https://keongkee.com.my/api/public/static/default.jpeg';

  shop: string;
  title: string;
  logo = '';
  newUiOnly = false;
  version = '';

  categories: Array<any> = [];
  promotions: Array<any> = [];

  loadingMenu = true;
  loadingPromo = true;

  query = '';
  searchResults: Array<any> = [];

  private allDishes: Array<any> = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private uiMode: UiModeService
  ) { }

  ngOnInit() {
    this.version = this.uiMode.version;

    this.route.queryParams.subscribe(params => {
      this.uiMode.scrollToTop();
      this.shop = params.shop || this.uiMode.shopFromHost();
      this.title = this.uiMode.titleFor(this.shop);
      this.logo = this.uiMode.logoFor(this.shop);
      this.newUiOnly = this.uiMode.isNewUiOnly(this.shop);
      this.fetchMenu();
      this.fetchPromotions();
    });
  }

  fetchMenu() {
    this.loadingMenu = true;
    this.apiService.fetchMenu(this.shop).subscribe(
      (data: Array<any>) => {
        this.categories = data || [];
        this.buildDishIndex();
        this.loadingMenu = false;
      },
      () => {
        this.categories = [];
        this.loadingMenu = false;
      }
    );
  }

  fetchPromotions() {
    this.loadingPromo = true;
    this.apiService.fetchPromotion(this.shop).subscribe(
      (data: Array<any>) => {
        this.promotions = (data || []).filter(p => p.active !== false);
        this.loadingPromo = false;
      },
      () => {
        this.promotions = [];
        this.loadingPromo = false;
      }
    );
  }

  private buildDishIndex() {
    const index = [];
    this.categories.forEach(cat => {
      (cat.dishPayloadList || []).forEach(dish => {
        if (dish.hide !== 'true') {
          index.push({ dish: dish, catId: cat.id, subId: null, path: cat.name });
        }
      });
      (cat.subMenuPayloadList || []).forEach(sub => {
        (sub.dishPayloadList || []).forEach(dish => {
          if (dish.hide !== 'true') {
            index.push({ dish: dish, catId: cat.id, subId: sub.id, path: cat.name + ' · ' + sub.name });
          }
        });
      });
    });
    this.allDishes = index;
  }

  onSearch(value: string) {
    this.query = (value || '').trim();
    if (this.query.length === 0) {
      this.searchResults = [];
      return;
    }
    const q = this.query.toLowerCase();
    this.searchResults = this.allDishes
      .filter(r => (r.dish.name || '').toLowerCase().indexOf(q) > -1)
      .slice(0, 20);
  }

  goCategory(cat) {
    if (cat.subMenuPayloadList && cat.subMenuPayloadList.length > 0) {
      this.router.navigate(['/v2/category'], { queryParams: { shop: this.shop, cat: cat.id } });
    } else if (cat.dishPayloadList && cat.dishPayloadList.length > 0) {
      this.router.navigate(['/v2/dishes'], { queryParams: { shop: this.shop, cat: cat.id } });
    }
  }

  goSearchResult(result) {
    const params: any = { shop: this.shop, cat: result.catId };
    if (result.subId) {
      params.sub = result.subId;
    }
    this.router.navigate(['/v2/dishes'], { queryParams: params });
  }

  goPromotions() {
    this.router.navigate(['/v2/promotions'], { queryParams: { shop: this.shop } });
  }

  backToClassic() {
    if (this.newUiOnly) {
      return;
    }
    this.uiMode.setMode('classic');
    this.router.navigate(['/menu'], { queryParams: { shop: this.shop } });
  }

  onImgError(event) {
    event.target.src = this.defaultImage;
  }
}
